import { styled } from "@mui/material/styles";
import { Box, Button, LinearProgress, Paper } from "@mui/material";

export const PRIMARY_COLOR = "#f58220";
export const SECONDARY_COLOR = "#02b7cf";
export const NEUTRAL_100 = "#f5f5f5";
export const NEUTRAL_800 = "#262626";
export const SUCCESS_COLOR = "#10b981";
export const ERROR_COLOR = "#ef4444";

export const UploadContainer = styled(Paper)({
  border: `2px dashed ${PRIMARY_COLOR}40`,
  borderRadius: "16px",
  padding: "2rem",
  minHeight: "180px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "16px",
  position: "relative",
  background: `linear-gradient(145deg, ${PRIMARY_COLOR}04, ${SECONDARY_COLOR}03)`,
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  cursor: "pointer",
  "&:hover": {
    borderColor: `${SECONDARY_COLOR}60`,
    background: `linear-gradient(145deg, ${SECONDARY_COLOR}06, ${PRIMARY_COLOR}04)`,
    transform: "scale(1.01)",
  },
  "&.uploading": {
    borderColor: PRIMARY_COLOR,
    background: `${PRIMARY_COLOR}08`,
  },
  "&.success": {
    borderColor: SUCCESS_COLOR,
    background: `${SUCCESS_COLOR}08`,
  },
  "&.error": {
    borderColor: ERROR_COLOR,
    background: `${ERROR_COLOR}08`,
  },
  "&.dragover": {
    borderColor: SECONDARY_COLOR,
    background: `${SECONDARY_COLOR}12`,
    transform: "scale(1.02)",
    boxShadow: `0 8px 32px ${SECONDARY_COLOR}20`,
  },
});

export const ModernProgressBar = styled(LinearProgress)({
  borderRadius: "8px",
  height: "8px",
  backgroundColor: NEUTRAL_100,
  "& .MuiLinearProgress-bar": {
    background: PRIMARY_COLOR,
    borderRadius: "8px",
  },
});

export const UploadButton = styled(Button)({
  borderRadius: "12px",
  padding: "12px 24px",
  fontWeight: 600,
  textTransform: "none",
  fontSize: "16px",
  background: PRIMARY_COLOR,
  color: "#fff",
  border: "none",
  boxShadow: "0 4px 16px rgba(245, 130, 32, 0.25)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 24px rgba(245, 130, 32, 0.35)",
    background: `${PRIMARY_COLOR}dd`,
  },
  "&:disabled": {
    opacity: 0.6,
    transform: "none",
    boxShadow: "none",
    background: "#9ca3af",
  },
});

export const FileInfoCard = styled(Box)({
  background: "rgba(255, 255, 255, 0.9)",
  borderRadius: "12px",
  padding: "16px",
  border: `1px solid ${NEUTRAL_100}`,
  backdropFilter: "blur(10px)",
  width: "100%",
});
